import { render } from "./ErrorPopup.vue?vue&type=template&id=ef1b0d00"
import script from "./ErrorPopup.vue?vue&type=script&lang=js"
export * from "./ErrorPopup.vue?vue&type=script&lang=js"

import "./ErrorPopup.vue?vue&type=style&index=0&id=ef1b0d00&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__